import { Outlet } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import Navbar from '../components/Navbar'
import Footer from '../components/footer';
import AccessibilityWidget from '../components/AccessibilityWidget';
import '../components/AccessibilityWidget.css';

const MainLayout = () => {
  return (
    <>
      {/* Skip to main content for screen readers */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      
      <ScrollToTop />
      <Navbar />
      <main id="main-content" className="bg-pattern-light">
        <Outlet />
      </main>
      <Footer />
      <AccessibilityWidget />
    </>
  )
}

export default MainLayout